export default __webpack_public_path__ + "static/media/ITTEFAQ.60a356d7.png";